import { render } from "./UpdateOfferingAccess.vue?vue&type=template&id=0c755cbe&scoped=true"
import script from "./UpdateOfferingAccess.vue?vue&type=script&lang=js"
export * from "./UpdateOfferingAccess.vue?vue&type=script&lang=js"

import "./UpdateOfferingAccess.vue?vue&type=style&index=0&id=0c755cbe&scoped=true&lang=scss"

import exportComponent from "/tmp/tmp.J0U5ZeTglF/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c755cbe"]])

export default __exports__